import { axios, axiosHelper } from "@/axios";

export const activityService = {
  getActivities: function (bodt) {
    return axios.post("/api/fetch_activity", bodt)
    .then(axiosHelper.handleResponse)
    .then((actvities) => {
      return actvities;
    });
  }
};
